/**
 * Лічильник «щось приїхало» — щоб відкритий екран не показував учорашнє.
 *
 * Без нього «написав на ноутбуці — бачу на телефоні» виконується лише
 * формально: дельта лягає в базу, а екран, який уже змальований, про це
 * не дізнається до наступного переходу. Телефон лежить відкритий і
 * мовчить.
 *
 * Модуль навмисно крихітний і не тягне нічого: його імпортують і екрани
 * (холодний старт), і рушій (лінивий шматок). Усе, що складніше за
 * лічильник, довелося б тримати в одному з двох, і будь-який вибір був
 * би неправильний для другого.
 */
import { useSyncExternalStore } from "react";

let revision = 0;
const listeners = new Set<() => void>();

/** Кличеться аплаєром **лише тоді**, коли застосування щось змінило. */
export function bumpSyncRevision(): void {
  revision += 1;
  for (const notify of listeners) notify();
}

function subscribe(notify: () => void): () => void {
  listeners.add(notify);
  return () => listeners.delete(notify);
}

const snapshot = () => revision;

/**
 * Число, яке росте на кожну застосовану пачку. Кладеться в деки
 * перечитування — цього досить, щоб екран оновився сам.
 *
 * ⚠️ Відкритий редактор його **не** слухає: підміняти текст під курсором
 * не можна. Чужі абзаци зʼявляться при наступному відкритті запису.
 */
export function useSyncRevision(): number {
  return useSyncExternalStore(subscribe, snapshot, snapshot);
}
